
import VuePicker from 'vue-pickers'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getDisplayName, getuserCurrentApp,getToken } from '@/utils/cookies.ts'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { NETWORKISSUESAPI } from '@/api/network'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import { problemList } from '@/utils/consts'
import { baseURL } from '@/api/administration'

@Component({
  name: 'networkYunWeiTicket'
})
export default class extends Vue {
  private activeName = 'network_yunwei_ticket';
  @Prop({ default: false }) private editForm!: any // 编辑表单时用到的表单数据
  private editId = 0
  private isDisableSubmit = false // 避免重复触发提交按钮
  private locationOptions = [] // 所在地区options
  private issueTypeOptions = [] // 问题类型options
  private commonTypeOptions = [] // 通用配置类型

  // 联动下拉框手机端
  private pickerIssueVisible = false // 点击所在地区文本框，显示picker联动
  private defaultIssueIndex = [] as number[] // 默认联动定位，从0开始，0代表第一行
  private NetworkIssueCn = '' // 移动端：所在地区内容
  private userInputValue = ''
  private network_ticket_usercount = 0
  private resolve_minutes = 0 // 完成时长
  private localEditForm: any = null // 新增本地副本
  formData = {
    // tutorName: this.username,
    // issueDate: new Date(),
    location: [] as any,
    describe: '',
    creator: this.userWorkCode,
    creator_cn: this.username,
    accept_user_cn: this.username,
    accept_user: this.userWorkCode,
    create_time: '',
    finish_time: '',
    solution: '',
    issue_type: '',
    problem_attr: '1',
    is_live_influenced: 0,
    network_ticket_dealusers: [] as any,
    network_ticket_usercount: 0,
    network_ticket_issuetype: { id: 6, name: 'xx' },
    network_ticket_location: '',
    remark: '',
    fileList: [] as Array<{ image_url: string; name: string }>
  }

  formRules: object = {
    creator: [{ required: true, message: '请输入发起人名称', trigger: ['blur', 'change'] }],
    accept_user_cn: [{ required: true }],
    network_ticket_location: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
    create_time: [{ required: true, message: '请选择日期', trigger: 'change' }],
    finish_time: [{ required: true, message: '请选择日期', trigger: 'change' }],
    network_ticket_issuetype: [{ required: true, message: '请选择问题源' }],
    network_ticket_dealusers: [{ required: true, message: '特需网络负责工程师', trigger: 'change' }]
  }

  pickerOptions: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  }

  get getToken() {
    return getToken
  }

  private beforeRemove(file: any) {
    return this.$confirm(`确定移除 ${file.name}？`)
  }

  get uploadImgUrl() {
    return baseURL + 'xz/uploadImage'
  }

  handleExceed(files: any, fileList: any) {
    this.$message.warning(
      `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
      } 个文件`
    )
  }

  // 上传前的处理
  beforeUpload(file: File) {
    const isValidSize = file.size / 1024 / 1024 < 10 // 10MB 限制
    if (!isValidSize) {
      this.$message.error('文件大小不能超过 10MB')
    }
    return isValidSize // 返回 true 表示允许上传，返回 false 表示阻止上传
  }

  handleSuccess(res: any) {
    if (res.stat === 1) {
      this.formData.remark = res.data.image_url
    }
  }

  // 删除用户
  private handleDelUser(index: number) {
    this.formData.network_ticket_dealusers.splice(index, 1)
  }

  // 添加用户
  private handleAddUser(user: any) {
    const isRepeat = this.formData.network_ticket_dealusers.some((item: any) => {
      return item.workcode === user.workcode
    })
    if (user && !isRepeat) {
      (this.formData.network_ticket_dealusers as any).push(user)
    }
    this.userInputValue = ''
  }

  // 获取需求类型
  private async getCommonType() {
    const options = ConfigModule.commonTypeOptions
    if (options.length <= 0) { // 仅首次打开时请求
      const response = await CONFIGAPI.getCommonTypeList({ app_id: this.userCurrentApp, type_code: 2 })
      // 确保 data 结构正确
      if (response.data && response.data.lists) {
        this.commonTypeOptions = response.data.lists
        ConfigModule.setCommonTypeOptions(response.data.lists) // 只存 `data.data`
      } else {
        console.error('接口返回数据格式不正确', response)
        this.commonTypeOptions = [] // 避免报错
      }
    } else {
      console.log('use cache......')
      this.commonTypeOptions = options // 直接使用缓存
    }
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isEdit() {
    return !!this.localEditForm && this.localEditForm.network_ticket_type !== 0
  }

  get problemList() {
    return problemList
  }

  // 标题
  get formTitle() {
    let title = '网络'
    // title += this.ticketType === 2 ? '班主任' : 'LP(学规)'
    title += this.isEdit ? '工单编辑' : '工单录入'
    return title
  }

  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get username() {
    return getDisplayName()
  }

  get userWorkCode() {
    return UserModule.workcode
  }

  get isMobile() {
    return AppModule.device === DeviceType.Mobile
  }

  // 响应
  @Watch('formData.create_time', { deep: true })
  private watchAccepTime(newVal: string, oldVal: string) {
    if (newVal === null) {
      this.resolve_minutes = 0
      return
    }
    if (this.formData.finish_time) {
      const response_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      const happend_time_tmp = this.formData.create_time.replace(/-/g, '/')
      const response_time = new Date(response_time_tmp).getTime()
      const happend_time = new Date(happend_time_tmp).getTime()
      const minuteDiff = Math.trunc((response_time - happend_time) / 1000 / 60) // 分钟
      if (minuteDiff < 0) {
        this.$message({
          message: '问题响应时间需大于问题发生时间！',
          type: 'error'
        })
        this.resolve_minutes = 0
      } else {
        this.resolve_minutes = minuteDiff
      }
    }
  }

  private handleClick(tab: object, event: object) {
    console.log(tab, event)
  }

  // 完成
  @Watch('formData.finish_time', { deep: true })
  private watchFinishTime(newVal: string, oldVal: string) {
    if (newVal === null) {
      this.resolve_minutes = 0
      return
    }
    if (this.formData.create_time) {
      const resolve_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      const response_time_tmp = this.formData.create_time.replace(/-/g, '/')
      const resolve_time = new Date(resolve_time_tmp).getTime()
      const response_time = new Date(response_time_tmp).getTime()
      const minuteDiff = Math.trunc((resolve_time - response_time) / 1000 / 60) // 分钟
      if (minuteDiff < 0) {
        this.$message({
          message: '完成时间需大于开始时间！',
          type: 'error'
        })
        this.resolve_minutes = 0
      } else {
        this.resolve_minutes = minuteDiff
      }
    }
  }

  @Watch('locationOptions')
  private watchLocationOptions(newVal: any, oldVal: any) {
    if (this.isEdit) {
      this.handleChangeLocation(this.formData.location)
    }
  }

  @Watch('editForm', { immediate: true, deep: true })
  onEditFormChange(newVal: object) {
    if (!newVal || Object.keys(newVal).length === 0) {
      this.localEditForm = {
        location: null,
        describe: '',
        creator: '',
        creator_cn: '',
        accept_user_cn: '',
        accept_user: '',
        create_time: '',
        finish_time: '',
        solution: '',
        issue_type: null,
        problem_attr: '',
        is_live_influenced: 0,
        network_ticket_type: 0
      }
    } else {
      this.localEditForm = JSON.parse(JSON.stringify(newVal))
    }
  }

  mounted() {
    this.getLmpLocation()
    this.getIssueType() // 获取问题类型
    this.getCommonType()

    // 编辑时location值设置
    if (this.isEdit) {
      this.assignFormdata()
      this.handleChangeLocation(this.formData.location)
    }
  }

  // 用户姓名/工号输入建议
  private querySearchUser(queryString: string, callback: any) {
    CONFIGAPI.getUsersData({
      key: queryString
    }).then((res) => {
      if (res.stat === 1) {
        callback(res.data)
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 选中用户
  private handleSelectCreator(user: any) {
    (this.$refs.tutorForm as any).clearValidate('creator')

    this.formData.creator_cn = user.name
    this.formData.creator = user.workcode
  }

  // 获取问题类型
  private async getIssueType() {
    const options = ConfigModule.issueTypeOptions
    if (options.length <= 0) { // 仅首次打开时请求
      const { data } = await CONFIGAPI.getIssuesType({ app_id: this.userCurrentApp })
      const newData: any = []
      // 删掉掉没有基地的地区
      data.map((item: any) => {
        if (item.children && item.children.length !== 0) {
          newData.push(item)
        }
      })
      this.issueTypeOptions = newData
      ConfigModule.setIssueTypeOptions(newData)
    } else {
      this.issueTypeOptions = options
    }
  }

  private formatDateTime(time: any) {
    const dateTime = new Date(time)
    const year = dateTime.getFullYear()
    const month = dateTime.getMonth() + 1
    const date = dateTime.getDate()
    const hour = dateTime.getHours()
    const minute = dateTime.getMinutes()
    return `${year}-${this.addZero(month)}-${this.addZero(date)} ${this.addZero(hour)}:${this.addZero(minute)}`
  }

  private addZero(v: any) {
    return v < 10 ? '0' + v : v
  }

  private handleChangeLocation(value: any) {
    // console.log('下拉框改变', value)
  }

  // 获取班主任所在地区列表
  private async getLmpLocation() {
    try {
      // 请求后端接口
      const { data } = await CONFIGAPI.getLmpLocation({ app_id: this.userCurrentApp })

      // 提取并处理接口返回的 data_list
      const newData = data.map((item: any) => ({
        code: item.code,
        name: item.name
      })) || []

      // 将处理后的数据赋值给 locationOptions
      this.locationOptions = newData
    } catch (error) {
      console.error('获取地区数据失败', error)
    }
  }

  // 移动端：所在地区联动确认
  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.NetworkIssueCn = issueType.join('/')
    this.formData.location = [res[0].value || res[0].id, res[1].value || res[1].id, res[2] ? res[2].value || res[2].id : '']
  }

  // 编辑赋值
  assignFormdata() {
    this.editId = this.localEditForm.id
    const editLocationType: any = [this.localEditForm.location.place_id, this.localEditForm.location.building_id, this.localEditForm.location.floor_id]
    const editIssueType: any = [this.localEditForm.issue_type.pid, this.localEditForm.issue_type.id]
    this.formData = {
      is_live_influenced: this.localEditForm.is_live_influenced,
      location: editLocationType,
      describe: this.localEditForm.describe,
      creator: this.localEditForm.creator.workcode,
      creator_cn: this.localEditForm.creator.name,
      accept_user_cn: this.localEditForm.accept_user.name,
      accept_user: this.localEditForm.accept_user.workcode,
      create_time: this.localEditForm.create_time,
      finish_time: this.localEditForm.finish_time,
      problem_attr: String(this.localEditForm.problem_attr),
      solution: this.localEditForm.solution || '',
      issue_type: editIssueType,
      network_ticket_dealusers: this.localEditForm.network_ticket_dealusers,
      network_ticket_usercount: this.localEditForm.network_ticket_usercount,
      network_ticket_issuetype: this.localEditForm.network_ticket_issuetype,
      network_ticket_location: this.localEditForm.network_ticket_location,
      remark: this.localEditForm.remark,
      fileList: [
        {
          name: this.localEditForm.remark,
          image_url: this.localEditForm.remark
        }
      ]

    }
    this.NetworkIssueCn = this.localEditForm.location.place + '/' + this.localEditForm.location.building + '/' + this.localEditForm.location.floor

    if (this.localEditForm.finish_time && this.localEditForm.create_time) {
      const accept_time_tmp = this.formData.create_time.replace(/-/g, '/')
      const finish_time_tmp = this.formData.finish_time.replace(/-/g, '/')
      const accept_time = new Date(accept_time_tmp).getTime()
      const finish_time = new Date(finish_time_tmp).getTime()
      const minuteDiff = (finish_time - accept_time) / 1000 / 60 // 分钟
      this.resolve_minutes = Math.trunc(minuteDiff)
      if (finish_time - accept_time < 0) {
        this.$message({
          message: '完成时间需要大于开始时间！',
          type: 'error'
        })
      }
    }
  }

  handleSubmit(formName: string) {
    const resolve_time_tmp = this.formData.finish_time.replace(/-/g, '/')
    const response_time_tmp = this.formData.create_time.replace(/-/g, '/')

    if (new Date(resolve_time_tmp).getTime() - new Date(response_time_tmp).getTime() < 0) {
      this.$message({
        message: '问题完成时间需大于问题开始时间！',
        type: 'error'
      })
      return
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'manualAdd'
        await (NETWORKISSUESAPI as any)[action]({
          location: 0,
          // 网络运维工单
          network_ticket_type: 7,
          describe: this.formData.describe,
          creator: this.formData.creator,
          creator_cn: this.formData.creator_cn,
          accept_user: this.formData.accept_user,
          accept_user_cn: this.formData.accept_user_cn,
          create_time: this.formData.create_time,
          finish_time: this.formData.finish_time ? this.formData.finish_time : null,
          issue_type: this.formData.issue_type,
          users: this.formData.network_ticket_dealusers,
          network_ticket_usercount: this.formData.network_ticket_usercount,
          network_ticket_location: this.formData.network_ticket_location,
          network_ticket_issuetype: typeof this.formData.network_ticket_issuetype === 'object'
            ? this.formData.network_ticket_issuetype.id
            : this.formData.network_ticket_issuetype,
          remark: this.formData.remark
        }, {
          app_id: this.userCurrentApp
        }).then((res: any) => {
          if (res.stat === 1) {
            this.$message.success('提交成功')
            this.handleResetForm(formName)
            this.$router.push({ path: '/home' })
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleEditSubmit(formName: string) {
    const finish_time_tmp = this.formData.finish_time.replace(/-/g, '/')
    const create_time_tmp = this.formData.create_time.replace(/-/g, '/')
    // 确保 issue_type 是单个的整数 ID
    const issueType = Array.isArray(this.formData.issue_type) ? this.formData.issue_type[0] : this.formData.issue_type
    const formattedUsers = this.formData.network_ticket_dealusers
      .map((user: any) => `${user.name}-${user.workcode}`)
      .join(',')

    if (new Date(finish_time_tmp).getTime() - new Date(create_time_tmp).getTime() < 0) {
      this.$message({
        message: '完成时间需大于开始时间！',
        type: 'error'
      })
      return
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'manualEdit'
        await (NETWORKISSUESAPI as any)[action]({
          id: this.editId,
          network_ticket_location: this.formData.network_ticket_location,
          network_ticket_issuetype: typeof this.formData.network_ticket_issuetype === 'object'
            ? this.formData.network_ticket_issuetype.id
            : this.formData.network_ticket_issuetype,
          location: 0,
          network_ticket_type: 7,
          describe: this.formData.describe,
          is_live_influenced: this.formData.is_live_influenced,
          creator: this.formData.creator,
          creator_cn: this.formData.creator_cn,
          accept_user: this.formData.accept_user,
          accept_user_cn: this.formData.accept_user_cn,
          create_time: this.formData.create_time,
          finish_time: this.formData.finish_time ? this.formData.finish_time : null,
          problem_attr: Number(this.formData.problem_attr),
          solution: this.formData.solution,
          issue_type: issueType,
          network_ticket_dealusers: formattedUsers,
          network_ticket_usercount: this.formData.network_ticket_usercount,
          remark: this.formData.remark
        }, {
          app_id: this.userCurrentApp
        }).then((res: any) => {
          if (res.stat === 1) {
            this.$emit('handleSuccess', res)
            this.$emit('handleCloseDialog')
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleResetForm(formName: string) {
    this.NetworkIssueCn = ''
    this.defaultIssueIndex = [0, 0, 0]
    const form: any = this.$refs[formName]
    form.resetFields()
    this.formData.location = [0, 0, 0]
  }
}
